import { Select, SelectProps } from "@chakra-ui/react";
import React, { PropsWithChildren } from "react";

const ThemedSelectComponent = React.forwardRef<
  HTMLSelectElement,
  PropsWithChildren<SelectProps>
>(({ children, ...rest }, ref) => {
  return (
    <Select
      ref={ref}
      variant="outline"
      size="lg"
      rounded="none"
      borderColor="gray.400"
      _placeholder={{
        opacity: 0.4,
        color: "gray.400",
      }}
      {...rest}
    >
      {children}
    </Select>
  );
});

ThemedSelectComponent.displayName = "ThemedSelect";

export const ThemedSelect = ThemedSelectComponent;
